export type MenuItems = {
  label: string;
  icon: JSX.Element | string;
  path: string;
  allowedRoles?: string[];
  subMenu?: {
    label: string;
    path: string;
  }[];
};

export const menuItems: MenuItems[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "pi pi-home",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Services",
    path: "/dashboard/payin/services",
    icon: "pi pi-briefcase",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "History",
    path: "/dashboard/payin/history",
    icon: "pi pi-list",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Services",
    path: "/dashboard/payout/services",
    icon: "pi pi-send",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Transactions History",
    path: "/dashboard/payout/history",
    icon: "pi pi-history",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Fundings History",
    path: "/dashboard/payout/fundings-history",
    icon: "pi pi-wallet",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Manage webhook",
    path: "/dashboard/manage-webhook",
    icon: "pi pi-link",
  },
  {
    label: "Settings",
    path: "/dashboard/settings",
    icon: "pi pi-cog",
    allowedRoles: ["ENTERPRISE", "CUSTOMER", "SUPERADMIN", "ADMIN", "REVIEWER"],
  },
  {
    label: "Developers",
    path: "/dashboard/developers",
    icon: "pi pi-code",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
];
